import { css } from '@emotion/react';
import { escapeSVG } from './_functions';
import { FontSize } from './vendor/_rfs.mixin';
import { BorderRadius } from './mixins/_border-radius.mixin';


export default ($) => css`
  .breadcrumb {
    display: flex;
    flex-wrap: wrap;
    padding: ${$.breadcrumbPaddingY} ${$.breadcrumbPaddingX};
    margin-bottom: ${$.breadcrumbMarginBottom};
    ${new FontSize($.breadcrumbFontSize).include($)};
    list-style: none;
    background-color: ${$.breadcrumbBg};
    ${new BorderRadius($.breadcrumbBorderRadius).include($)};
  }

  .breadcrumb-item {
    & + .breadcrumb-item {
      padding-left: ${$.breadcrumbItemPadding};

      &::before {
        float: left;
        padding-right: ${$.breadcrumbItemPadding};
        color: ${$.breadcrumbDividerColor};
        content: ${escapeSVG($.breadcrumbDivider)};
      }
    }

    & + .breadcrumb-item:hover::before {
      text-decoration: underline;
    }

    & + .breadcrumb-item:hover::before {
      text-decoration: none;
    }

    &.active {
      color: ${$.breadcrumbActiveColor};
    }
  }
`;

